module.exports = __webpack_public_path__ + "img/bjoh.7ab397f4.png";